import { FiltroConsultarEnvioMora, MoraNotas } from "../modelo/EnviosMoraModelo";

export const CONSULTAR_ENVIOS_MORA = "CONSULTAR_ENVIOS_MORA";
export const TABLA_ENVIOS_MORA_CONSULTADO = "TABLA_ENVIOS_MORA_CONSULTADO";
export const ERROR_CONSULTANDO_ENVIOS_MORA = "ERROR_CONSULTANDO_ENVIOS_MORA";

export const DESCARGAR_XLS_ENVIOS_MORA = "DESCARGAR_XLS_ENVIOS_MORA";
export const EXITO_DESCARGAR_ENVIOS_MORA_XLS = "EXITO_DESCARGAR_ENVIOS_MORA_XLS";
export const ERROR_DESCARGAR_ENVIOS_MORA_XLS = "ERROR_DESCARGAR_ENVIOS_MORA_XLS";

export const consultarEnviosMora = (filtro: FiltroConsultarEnvioMora) => ({ type: CONSULTAR_ENVIOS_MORA, filtro});
export const tablaEnviosMoraConsultado = (datosEntidad: Array<MoraNotas>, paginas: number, totalDatos: number) => ({ 
    type: TABLA_ENVIOS_MORA_CONSULTADO, datosEntidad, paginas, totalDatos });
export const errorConsultandoEnviosMora = () => ({ type: ERROR_CONSULTANDO_ENVIOS_MORA });

export const descargarXlsEnviosMora = (filtro: FiltroConsultarEnvioMora) => ({ type: DESCARGAR_XLS_ENVIOS_MORA, filtro});
export const exitoDescargarEnviosMoraXls = () => ({ type: EXITO_DESCARGAR_ENVIOS_MORA_XLS});
export const errorDescargarEnviosMoraXls = () => ({ type: ERROR_DESCARGAR_ENVIOS_MORA_XLS});


// WEBPACK FOOTER //
// ./src/co/sura/dominio/sat/consulta_envio_mora/modulos/consultaEnvioMoraActions.ts